// extracted by mini-css-extract-plugin
export default {"cellWrapper":"TableCell_cellWrapper__i6AH4"};